import ListView from "@ckeditor/ckeditor5-ui/src/list/listview"

export default class SelectView extends ListView {
  constructor() {
    super()
    const bind = this.bindTemplate
    this.decorate("initFirst")

    this.set({ value: {} })

    this.setTemplate({
      tag: "select",

      attributes: {
        class: ["ck", "ck-reset", "ck-list"],
      },
      on: {
        change: bind.to((evt) => {
          const element = evt.target.selectedOptions[0]
          this.value = {
            id: this.getAppAffiliateTemplateIdFrom(element),
            name: this.getAppAffiliateTemplateNameFrom(element),
          }
        }),
      },

      children: this.items,
    })
  }
  initFirst() {
    const element = this.items.first.element
    this.value = {
      id: this.getAppAffiliateTemplateIdFrom(element),
      name: this.getAppAffiliateTemplateNameFrom(element),
    }
  }
  getAppAffiliateTemplateIdFrom(element) {
    return parseInt(
      element.children[0].getAttribute("app-affiliate-template-id"),
      10
    )
  }
  getAppAffiliateTemplateNameFrom(element) {
    return element.children[0].getAttribute("app-affiliate-template-name")
  }
}
